import type { CartDataSource } from '~/api/data-source/cart';
import { cartDataSource } from '~/api/data-source/cart';
import { cartCountSchema, parseModel } from '~/api/model';

export interface CartRepository {
  getCartCount(): Promise<number>;
  // Mutation
  updateECouponQuick(offerId: number): Promise<void>;
}

export class CartRepositoryImpl implements CartRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly dataSource: CartDataSource = cartDataSource) {}

  async getCartCount() {
    const response = await this.dataSource.getCartCount();
    return parseModel(cartCountSchema, response, 'CartCount');
  }

  async updateECouponQuick(offerId: number) {
    return this.dataSource.updateECouponQuick(offerId);
  }
}

export const cartRepository = new CartRepositoryImpl();
